/**
 * @description 订单支付-post请求体
 * @url http://api.hljnbw.cn/project/705/interface/api/113498
 * @updateDate 2022-04-27 11:28:14
 */
export interface PayPayReqBody {
  /** 订单主表id，必传 */
  merchantOrderId: number
  /** 交易类型细分，必传(11-支付宝扫码支付12-支付宝H5支付13-支付宝app支付21-微信扫码支付22-微信H5支付23-微信APP支付31-线下打款41-钱包) */
  transWayChannel: number
  /** 支付中心类型：PI-XIU */
  payCenterType: string
  /** 支付宝微信H5支付-支付成功时的回调地址 */
  returnUrl: string
  /** 线下打款备注 */
  remark: string
  /** 打款凭证，线下支付必传 */
  attach: string[]
  /** 客户端ip */
  ip: string
}

/**
 * @description 订单支付-响应体
 * @url http://api.hljnbw.cn/project/705/interface/api/113498
 * @updateDate 2022-04-27 11:28:14
 */
export interface PayPayResBodyData {
  /** 支付系统单号 */
  payNo: string
  /** 业务系统订单号 */
  orderNo: string
  /** 二维码码串 */
  qrCode: string
  /** H5支付参数 */
  h5PayInfo: string
  /** app支付参数 */
  appPayInfo: string
  /** POS机支付参数 */
  posMachinePayInfo: {
    id: number
    /** 唯一标识 */
    tradeNo: string
    /** 订单id */
    orderId: number
    /** 商家id */
    merchantId: number
    /** 本次POS机支付的总支付金额(单位：分) */
    totalPayAmount: number
    /** 加密后的信息 */
    encryptContent: string
  }
  merchantOrderId: number
}
/**
 * @description 查询支付宝微信的支付状态-query请求参数
 * @url http://api.hljnbw.cn/project/705/interface/api/114653
 * @updateDate 2022-04-26 09:52:39
 */
export interface PayPayStatusReqQuery {
  /** 支付方式：2-支付宝 1-微信 */
  payType?: string
  /** 支付系统单号 */
  payNo?: string
  /** 业务系统订单号 */
  orderNo?: string
  /** 支付中心的type值 */
  payCenterType?: string
  /** 订单主表ID */
  orderId: number
}

/**
 * @description 查询支付宝微信的支付状态-响应体
 * @url http://api.hljnbw.cn/project/705/interface/api/114653
 * @updateDate 2022-04-26 09:52:39
 */
export interface PayPayStatusResBodyData {
  /** 产品名称 */
  productName: string
  /** 总支付金额 */
  totalPayAmount: number
  /** 已支付金额 */
  paidAmount: number
  /** 订单id */
  orderId: number
  /** 订单编号 */
  orderNo: string
  /**      * 订单状态      * NO_COMMIT(1, "待提交"),      * NO_APPROVE(2, "待价格审批"),      * NO_SEND(3, "待发送"),      * NO_SIGN(4, "待签合同"),      * NO_PAY(5, "未付款"),      * SOME_PAY(6, "部分付款"),      * SUCCESS_DONE(7, "已完成"),      * SUCCESS_CLOSE(8, "已关闭"); */
  orderStatus: number
  /** 支付状态 true-支付成功 false-支付失败 */
  paySuccess: boolean
}
/** 订单状态 */
export enum OrderStatusEnum {
  /** 待提交：1 */
  NO_COMMIT = 1,
  /** 待价格审批：2 */
  NO_APPROVE,
  /** 待发送：3 */
  NO_SEND,
  /** 待签合同：4 */
  NO_SIGN,
  /** 未付款：5 */
  NO_PAY,
  /** 部分付款：6 */
  SOME_PAY,
  /** 已完成：7 */
  SUCCESS_DONE,
  /** 已关闭：8 */
  SUCCESS_CLOSE
}
/**
 * @description 查询订单的信息-query请求参数
 * @url http://api.hljnbw.cn/project/705/interface/api/113512
 * @updateDate 2022-04-26 09:52:39
 */
export interface PayFindOrderInfoReqQuery {
  orderId?: string
}

/**
 * @description 查询订单的信息-响应体
 * @url http://api.hljnbw.cn/project/705/interface/api/113512
 * @updateDate 2022-04-26 09:52:39
 */
export interface PayFindOrderInfoResBodyData {
  /** 产品名称 */
  productName: string
  /** 总支付金额 */
  totalPayAmount: number
  /** 已支付金额 */
  paidAmount: number
  /** 订单id */
  orderId: number
  /** 订单编号 */
  orderNo: string
}
